export const SHIPPING_ITEM_PLACEHOLDER = 'Look up item'
export const PRODUCT_PLACEHOLDER = 'Product'
export const COMMODITY_PLACEHOLDER = 'Commodity'
